import { Avatar, Box, Checkbox, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Typography, makeStyles } from "@material-ui/core";
import { generatePaginationOptions } from "lib/helper";
import { cardChartStyle, flexGapStyle, fontTextStyle, iconStyle, tableStyle } from "modules/reporting/styles";
import React from "react";
import { useEffect } from "react";
import Chart from 'react-apexcharts';
import { useState } from "react";
import ApexCharts from 'apexcharts'
import downloadjs from 'downloadjs';
import html2canvas from 'html2canvas';
import { setChartColors } from "modules/reporting/utils/chartConfig";
import { DownloadIcon, UnknownUserIcon } from "modules/reporting/assets/svg";
import { drilldownPageSelection, responseHandler } from "modules/reporting/utils/helper";
import { TablePaginationActions } from "components/tablePagination";
import { ContentCard } from "../../layout";
import { BoxLoading } from "../../skeleton/loading";
import { CampaignConversionsNoData } from "../../skeleton/no-data";
import { CampaignConversionsNoResult } from "../../skeleton/no-result";
import { Link } from "react-router-dom";
import { TIER_ICON_PROPS } from "modules/stockflow/constants";

const checkBoxStyles = makeStyles({
    checkbox__cell: {
        color: props => props.color
    }
})

export default function StockoutDealerPanelComponent({
    translate,
    data,
    status,
    sort,
    pagination,
    currentFilter,
    pageType
}){

    const fontClasses = fontTextStyle();
    const flexGapClasses = flexGapStyle();
    const tableClasses = tableStyle();
    const iconClasses = iconStyle();
    const chartClasses = cardChartStyle();
    const [selected, setSelected] = useState([]);

    const [paginationOptions, setPaginationOptions] = useState([]);
    useEffect(() => {
        setPaginationOptions(generatePaginationOptions(data.dealerStockoutData ? data.dealerStockoutData.total_record : 0, [10, 25, 50, 100]))
    }, [data]);

    const columns = [
        {
            title: translate("label.NUM"),
            field: null,
            render: (row) => {
                return (
                    <>{row.title}</>
                )
            },
            align: "left",
            size: "medium"
        },
        {
            title: translate("label.DEALER"),
            field: null,
            render: (row) => {
                return (
                    <>{row.title}</>
                )
            },
            align: "left",
            size: "medium"
        },
        // {
        //     title: translate("label.TIER"),
        //     field: "tier",
        //     render: (row) => {
        //         return (
        //             <>{row.title}</>
        //         )
        //     },
        //     align: "left",
        //     size: "medium"
        // },
        {
            title: translate("label.UPLINE"),
            field: "stockout_count",
            render: (row) => {
                return (
                    <>{row.title}</>
                )
            },
            size: "small",
            align: "left"
        },
        {
            title: translate("label.TOTAL_STOCKOUT"),
            field: "stockout_count",
            render: (row) => {
                return (
                    <>{row.title}</>
                )
            },
            size: "small",
            align: "left"
        },
        // {
        //     title: translate("label.TOTAL_STOCKOUT_WEIGHTAGE"),
        //     field: null,
        //     render: (row) => {
        //         return (
        //             <>{row.title}</>
        //         )
        //     },
        //     size: "small",
        //     align: "left"
        // }
    ]

    // download chart
    const handleDownloadCard = () => {
        let element = document.getElementById("stockout-by-dealer");

        html2canvas(element).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            downloadjs(imgData, 'stockout-by-dealer.png');
        });

    }

        // apexchart configuration & function
    const chartID = "stockout-dealer-chart";

    const CheckboxComponent = ({children, ...props}) => {
        const { checkbox__cell } = checkBoxStyles(props);
        const { checked, onClick, inputProps } = props;

        return (
            <Checkbox
                className={`${checkbox__cell}`}
                checked={checked}
                onClick={onClick}
                inputProps={inputProps}
            />
        )
    }

    const onSelectAllClick = (event) => {
        if (!event.target.checked){
            const newSelecteds = data.dealerStockoutByProductData.rows.map((n) => n.name);
            hideAll();
            setSelected(newSelecteds);
        } else {
            showAll();
            setSelected([]);
        }
    }

    const hideAll = () => {
        data.dealerStockoutByProductData.rows.forEach((n) => {
            ApexCharts.exec(chartID, 'hideSeries', n.name);
        })
    }

    const showAll = () => {
        data.dealerStockoutByProductData.rows.forEach((n) => {
            ApexCharts.exec(chartID, 'showSeries', n.name);
        })
    }

        const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
        toggle(name)
    }

    const toggle = (name) => {
        ApexCharts.exec(chartID, 'toggleSeries', name);
    }

    const createSortHandler = (property) => (event) => {
        sort.handleRequestSort(event, property);
    };

    const displayData = (ref) => {
        let rows = [];
        if(Object.keys(ref).length === 0 || !ref.isSuccess){
            return rows;
        }

        const colorSet = setChartColors(ref.chart.datasets.length, true);

        const options = {
            chart: {
                id: chartID
            },
            tooltip:{
                followCursor: true,
                y: {
                    formatter: function (val) {
                        return parseInt(val)
                    }
                }
            },
            xaxis: {
                categories: ref.chart.labels,
                labels: {
                    rotateAlways: true,
                    rotate: -45,
                    hideOverlappingLabels: true,
                },
                tickPlacement: 'between',
            },
            legend: {
                position: 'bottom',
                showForSingleSeries: true,
                onItemClick: {
                    toggleDataSeries: false
                }
            },
            grid: {
                padding: {
                    left: 12,
                    right: 12,
                }
            },
            stroke: {
                width: 2,
            },
            colors: colorSet
    
        }

        let no_iteration = pagination.rowsPerPage * pagination.page + 1;

        return (
            <Box
                className={chartClasses.card}    
            >
                <Chart
                    options={options}
                    series={ref.chart.datasets}
                    type="line"
                    height="430px"
                ></Chart>
                <TableContainer component={ Paper }>
                    <Box style={{
                        overflowX: "auto",
                        width: "100%"
                    }}>
                        <Table>
                            <TableHead>
                                <TableRow
                                    hover
                                >
                                    <TableCell
                                        padding="checkbox"
                                        className={tableClasses.table__cell}
                                    >
                                        <Checkbox 
                                            onChange={onSelectAllClick}
                                            indeterminate={selected.length > 0 && selected.length < ref.rows.length}
                                            checked={ref.rows.length > 0 && selected.length === 0}
                                        />
                                    </TableCell>
                                    {columns.map((column, index) => (
                                        <TableCell className={[tableClasses.table__cell, fontClasses.text__header_table_cell]} key={column.title} size={column.size}>
                                            {
                                                column.field ? 
                                                (
                                                    <TableSortLabel
                                                        active={sort.valueToOrderBy === column.field ? true : false}
                                                        direction={sort.valueToOrderBy === column.field ? sort.orderDirection : 'desc'}
                                                        onClick={!status.isFetchingDealerStockoutByBranch && column.field ? createSortHandler(column.field) : null}
                                                    >
                                                        {column.render(column)}
                                                    </TableSortLabel>
                                                ) : 
                                                column.render(column)
                                            }
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {ref.rows.map((item, index) => {
                                    const isItemSelected = selected.indexOf(item.name) !== -1;
                                    const labelId = `enhanced-table-checkbox-${item.name}`;

                                    return (
                                        <TableRow
                                            hover
                                            aria-checked={isItemSelected}
                                            key={item.name}
                                            selected={isItemSelected}
                                        >
                                            <TableCell 
                                                padding="checkbox"
                                                className={tableClasses.table__cell}
                                            >
                                                <CheckboxComponent 
                                                    checked={!isItemSelected}
                                                    onClick={(event) => handleClick(event, item.name)}
                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                    color={colorSet[index] + ' !important'}
                                                />
                                            </TableCell>
                                            <TableCell className={tableClasses.table__cell} style={{width: "20px"}}>
                                                <Typography className={fontClasses.text__table_cell}>{no_iteration++}</Typography>
                                            </TableCell>
                                            <TableCell className={tableClasses.table__cell} style={{width:"400px", minWidth:"400px"}}>
                                                {
                                                    item.uuid ? (
                                                        <Box className={tableClasses.cell__product}>
                                                            {
                                                                item.tier ? (
                                                                    <Box
                                                                        className={iconClasses.tierIcon}
                                                                        style={{
                                                                            backgroundColor: TIER_ICON_PROPS.find(({ tier }) => tier === item.tier).color
                                                                        }}
                                                                    >
                                                                        <Typography className={fontClasses.text__tier_label}>
                                                                            T{item.tier}
                                                                        </Typography>
                                                                    </Box>
                                                                ) : null
                                                            }
                                                            {
                                                                item.image ?
                                                                <Avatar variant="square" alt={item.name} src={item.image} className={iconClasses.svg__icon}/>
                                                                :
                                                                <Avatar variant="square" alt={item.name} src={UnknownUserIcon} className={iconClasses.svg__icon}/>
                                                            }
                                                        
                                                            <Link
                                                                target="_blank" rel="noopener noreferrer" 
                                                                className={fontClasses.text__hyperlink}
                                                                to={() => {
                                                                    let filterProperties = {};

                                                                    if (item.uuid) {
                                                                        filterProperties.dealershipUuid = item.uuid;
                                                                    }
                                                                    let url = drilldownPageSelection(filterProperties, pageType, true);
                                                                    return url;
                                                                }}
                                                            
                                                            >
                                                                {translate(item.name)}
                                                            </Link>
                                                        </Box>
                                                    ) : 
                                                    (
                                                        <Typography className={fontClasses.text__unknown}>-</Typography>
                                                    )
                                                }

                                            </TableCell>
                                            {/* <TableCell className={tableClasses.table__cell} align="right" style={{width: "120px", minWidth: "120px"}}>
                                                <Typography className={fontClasses.text__table_cell}>
                                                    {item.tier ? item.tier : <>-</>}
                                                </Typography>
                                            </TableCell> */}
                                            <TableCell className={tableClasses.table__cell} style={{width:"400px", minWidth:"400px"}}>
                                                {
                                                    item.upline_uuid ? 
                                                    (
                                                        <Box className={tableClasses.cell__product}>
                                                            {
                                                                item.image ?
                                                                <Avatar variant="square" alt={item.upline_name} src={item.upline_image} className={iconClasses.svg__icon}/>
                                                                :
                                                                <Avatar variant="square" alt={item.upline_name} src={UnknownUserIcon} className={iconClasses.svg__icon}/>
                                                            }
                                                            <Link
                                                                target="_blank" rel="noopener noreferrer" 
                                                                className={fontClasses.text__hyperlink}
                                                                to={() => {
                                                                    let filterProperties = {};

                                                                    if(item.upline_uuid)
                                                                        filterProperties.dealershipUuid = item.upline_uuid;

                                                                    let url = drilldownPageSelection(filterProperties, pageType, true);
                                                                    
                                                                    return url;
                                                                }}
                                                            
                                                            >
                                                                {translate(item.upline_name)}
                                                            </Link>
                                                        </Box>
                                                    ) :
                                                    (
                                                        <Typography className={fontClasses.text__unknown}>-</Typography>
                                                    )
                                                }

                                            </TableCell>
                                            <TableCell className={tableClasses.table__cell} align="right" style={{width: "120px", minWidth: "120px"}}>
                                                <Typography className={fontClasses.text__table_cell}>
                                                    {item.total_stockout}
                                                </Typography>
                                            </TableCell>
                                            {/* <TableCell className={tableClasses.table__cell} align="right" style={{width: "120px", minWidth: "120px"}}>
                                                <Typography className={fontClasses.text__table_cell}>
                                                    {item.stockout_percentage}
                                                </Typography>
                                            </TableCell> */}
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </Box>
                    <TablePagination
                        ActionsComponent={TablePaginationActions}
                        component="div"

                        // rowsPerPageOptions={pagination.rowsPerPageOptions}
                        rowsPerPageOptions={paginationOptions}
                        rowsPerPage={pagination.rowsPerPage}
                        page={pagination.page}
                        count={ref.total_record ?? 0}
                        onChangePage={pagination.handleChangePage}
                        onChangeRowsPerPage={pagination.handleChangeRowPerPage}
                    />
                </TableContainer>
            </Box>
        )
    }

    return (
        <ContentCard>
            <Box
                display="flex"
                flexDirection="column"
                id="stockout-by-model"
            >
                {/* title and download icon/toggle icon */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    margin="24px 0"
                >
                    <Typography className={fontClasses.text__card_title}>
                        {translate("label.STOCKOUT_BY_DEALER")}
                    </Typography>
                    <Box display="flex" alignContent="center" className={flexGapClasses.global__flexGap20}>
                        <IconButton title="Download Charts" aria-label="download" onClick={handleDownloadCard} disableRipple>
                            <DownloadIcon />
                        </IconButton>
                    </Box>
                </Box>

                {
                    responseHandler(
                        data.dealerStockoutData,
                        status.isFetchingDealerStockout,
                        displayData(data.dealerStockoutData),
                        <BoxLoading />,
                        <CampaignConversionsNoData 
                            title={translate("label.DEALERSHIP_NOT_FOUND")}
                            value={translate("paragraph.NO_DATA_ON_SELECTED_FILTER")}
                            columnTitle={[translate("label.DEALER"), translate("label.UPLINE"), translate("label.TOTAL_STOCKOUT")]}
                            translate={translate}
                        />,
                        <CampaignConversionsNoResult 
                            title={translate("label.DEALERSHIP_NOT_FOUND")}
                            value={translate("paragraph.NO_DATA_ON_SELECTED_FILTER")}
                            columnTitle={[translate("label.DEALER"), translate("label.UPLINE"), translate("label.TOTAL_STOCKOUT")]}
                            translate={translate}
                        />,
                        <CampaignConversionsNoResult 
                            title={translate("label.LOADING_FAILED")}
                            value={translate("paragraph.LOADING_FAILED_DESCRIPTION")}
                            columnTitle={[translate("label.DEALER"), translate("label.UPLINE"), translate("label.TOTAL_STOCKOUT")]}
                            translate={translate}
                        />
                    )
                }
            </Box>
        </ContentCard>
    )
}